import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function rejectCanGoOutAloneAuthorization(id: number) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.rejectGoOutAloneAuthorization.url, { id }))
    .post()
}
